import { useCallback, useMemo } from 'react';

/**
 * Type guard to ensure valid event data.
 */ function isValidEventData(data) {
    return typeof data === 'object' && data !== null && 'type' in data;
}
/**
 * A hook that allows parent apps to send messages to the auth-web iFrame.
 */ const usePostMessageSender = (iFrameRef, { circleAuthUrl })=>{
    const sendMessage = useCallback((payload)=>{
        if (iFrameRef.current?.contentWindow == null) {
            return;
        }
        if (!isValidEventData(payload)) {
            return;
        }
        iFrameRef.current.contentWindow.postMessage(payload, circleAuthUrl);
    }, [
        circleAuthUrl,
        iFrameRef
    ]);
    return useMemo(()=>({
            sendMessage
        }), [
        sendMessage
    ]);
};

export { usePostMessageSender };
//# sourceMappingURL=usePostMessageSender.js.map
